import React from "react";
import { motion } from "framer-motion";
import { FileText, HeartPulse, Home, GraduationCap, Plane, ArrowUpRight } from "lucide-react";
import { FAMILY } from "@/data/content";

const ICONS = [FileText, HeartPulse, Home, GraduationCap, Plane];

export const FamilySupport = () => {
  return (
    <section id="family" className="py-20 md:py-28 bg-[#0e7d72] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#ffc247]">
            Polaris Family
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight mt-4 leading-tight">
            {FAMILY.title}
          </h2>
          <p className="mt-5 text-lg text-white/85 leading-relaxed">{FAMILY.subtitle}</p>
          <p className="mt-4 text-white/70 leading-relaxed">{FAMILY.intro}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FAMILY.categories.map((cat, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`family-cat-${i}`}
                className="bg-white/[0.06] border border-white/10 rounded-2xl p-7 hover:bg-white/[0.1] transition-colors"
              >
                <div className="w-11 h-11 rounded-xl bg-[#ffc247]/20 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-[#ffc247]" />
                </div>
                <h3 className="font-display text-xl font-bold mt-5">{cat.title}</h3>
                <ul className="mt-4 space-y-2">
                  {cat.items.map((it, idx) => (
                    <li key={idx} className="flex items-start gap-2.5 text-sm text-white/80">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#ffc247] mt-1.5 shrink-0" />
                      {it}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="bg-[#ffc247] text-[#2b2a33] rounded-2xl p-7 flex flex-col justify-between"
          >
            <div>
              <h3 className="font-display text-2xl font-extrabold leading-tight">
                ¿Necesitas apoyo para tu día a día?
              </h3>
              <p className="mt-3 text-sm font-medium text-[#2b2a33]/80">
                Diseñamos un plan a la medida de tu familia o tu agenda.
              </p>
            </div>
            <a
              href="#contacto"
              data-testid="family-cta"
              className="mt-6 inline-flex items-center justify-center gap-2 bg-[#2b2a33] text-white font-semibold px-5 py-3.5 rounded-full hover:bg-[#ff5c49] transition-colors"
            >
              Hablemos <ArrowUpRight className="w-4 h-4" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
